// ── ADVANCD design tokens ────────────────────────────────────────────────
// Theme-INDEPENDENT scales, shared by App.jsx and MobileApp.jsx. These mirror
// the CSS custom properties in index.css so inline styles and injected <style>
// blocks can both reference one source of truth.
//
// Color tokens are theme-DEPENDENT and live in the `UI` object in App.jsx
// (passed to MobileApp as a prop), because the light/dark theme is controlled
// by JS state (lightMode), not prefers-color-scheme.
//
// Usage:  import { TOK } from "./tokens.js";
//         style={{ borderRadius: TOK.radius.sm, fontSize: TOK.text.base }}

export const RADIUS = { xs: 4, sm: 8, md: 12, lg: 16, full: 999 };

// px. Floor raised to 11 (was 7–9 in places). Use weight/colour for hierarchy,
// not smaller type.
export const TEXT = { xs: 11, sm: 12, base: 14, lg: 16, xl: 20, xxl: 28, xxxl: 40 };

// 4px base spacing scale.
export const SPACE = { 1: 4, 2: 8, 3: 12, 4: 16, 6: 24, 8: 32, 12: 48 };

export const WEIGHT = { regular: 400, medium: 500, label: 600, heading: 700 };

export const MOTION = {
  fast: "120ms",
  base: "200ms",
  slow: "300ms",
  ease: "cubic-bezier(0.4, 0, 0.2, 1)",
};

// Convenience bundle.
export const TOK = {
  radius: RADIUS,
  text: TEXT,
  space: SPACE,
  weight: WEIGHT,
  motion: MOTION,
};

// ── Phone display normalizer ─────────────────────────────────────────────────
// App standard: xxx.xxx.xxxx. Any US-shaped number ((339) 364-0216,
// +1 339.364.0216, 13393640216, bare digits) renders identically; anything
// else (international, extensions) passes through untouched. Display-only —
// tel: hrefs and stored values keep their raw form.
export function fmtPhone(p) {
  if (!p) return p;
  let d = String(p).replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length === 10) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return String(p).trim();
}
